import { useMemo } from 'react';
import { IoIosArrowUp } from 'react-icons/io';
import { AircraftIcon } from '@icons';
import { TmdxAvatar } from '@ds';
import { AircraftMarkerListItem } from '@lp/features/RoutePlanner/types';
import { convertCrewViewToCrewResources } from '@lp/features/RoutePlanner/components/RouteLegForm/utils';
import { CrewLogisticsResourceType, LogisticsLegResourceType } from '@/api/apis/route';
import { CaseResourceType } from '@/api/apis/case';

type SelectedAircraftInfoProps = {
  aircraft: AircraftMarkerListItem | null;
  legResources: LogisticsLegResourceType[];
  crewResources: CrewLogisticsResourceType[];
  isOpen: boolean;
};

export const SelectedAircraftInfo = ({ aircraft, legResources, crewResources, isOpen }: SelectedAircraftInfoProps) => {
  const crewList = useMemo(() => {
    if (!aircraft) return [];

    const convertedCrewAvailabilities = convertCrewViewToCrewResources(aircraft.availabilities[0]?.crewDutyViews || []);
    const list = [...crewResources, ...convertedCrewAvailabilities];
    const crews = legResources.filter((r) => r.resourceType === CaseResourceType.Crew);

    return crews
      .map((c) => list.find((crewItem) => crewItem.resourceId === c.resourceId))
      .filter((i): i is CrewLogisticsResourceType => Boolean(i));
  }, [aircraft, legResources, crewResources]);

  if (aircraft) {
    return (
      <div className="w-full flex flex-row justify-between items-center">
        <div className="flex flex-row w-full gap-3 items-center">
          <div className="flex flex-row gap-3">
            <AircraftIcon height={16} width={16} />
            <p className="text-m-m text-base-5">{aircraft.registration}</p>
            {crewList.map((crewItem) => (
              <div key={crewItem.resourceId} className="flex gap-1 items-center">
                <TmdxAvatar type="user" size="sm" radius="full" />
                <span className="text-s-r tex-base-5">{`${crewItem.firstName || ''} ${crewItem.lastName || ''}`}</span>
              </div>
            ))}
          </div>
        </div>
        <IoIosArrowUp size={20} className={isOpen ? '' : 'rotate-180'} />
      </div>
    );
  }

  return (
    <div className="w-full flex flex-row justify-between items-center">
      <div className="flex flex-row gap-3 items-center">
        <AircraftIcon height={16} width={16} />
        <p className="text-s-sb">Select resource *</p>
      </div>
      <IoIosArrowUp size={20} className={isOpen ? '' : 'rotate-180'} />
    </div>
  );
};
